import React from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { Text } from 'wix-ui-tpa/cssVars';

import { IMAGE_ROUTE } from '../../../constants/image-route';
import { classes } from './DetailsCard.st.css';
import { StepThumbnail } from '../stylesParams';

type DetailsItem = {
  title?: string;
  description: string;
};

interface DetailsCardProps {
  step: number;
  title: string;
  details: DetailsItem[];
  iconPath: string;
  dataHook?: string;
  showTiers: boolean;
}

export const DetailsCard: React.FC<DetailsCardProps> = ({ step, title, details, iconPath, dataHook, showTiers }) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const showStepIndication = styles
    .getStylesForAllBreakpoints()
    .some((breakpointStyles) => breakpointStyles.booleans.showStepIndication);
  const showStepIcon = styles
    .getStylesForAllBreakpoints()
    .some((breakpointStyles) => breakpointStyles.numbers.cardsStepThumbnail === StepThumbnail.Icon);
  const showStepNumber = styles
    .getStylesForAllBreakpoints()
    .some((breakpointStyles) => breakpointStyles.numbers.cardsStepThumbnail === StepThumbnail.Numbers);

  const renderDetails = () => {
    if (showTiers) {
      return (
        <div className={classes.details}>
          {details.map((detail, index) => {
            return (
              <div key={index} className={classes.detail}>
                {detail.title ? (
                  <Text tagName="p" className={classes.detailTitle}>
                    {detail.title}
                  </Text>
                ) : null}
                <Text tagName="p" className={classes.detailDescription} data-hook={`${dataHook}-description-${index}`}>
                  {detail.description}
                </Text>
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <ul className={classes.details}>
        {details.map((detail, index) => {
          return (
            <li key={index} aria-label={t('app.role')} className={classes.detail}>
              {detail.title ? (
                <Text tagName="p" className={classes.detailTitle}>
                  {detail.title}
                </Text>
              ) : null}
              <Text tagName="p" className={classes.detailDescription} data-hook={`${dataHook}-description-${index}`}>
                {detail.description}
              </Text>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <li data-hook={dataHook} className={classes.root}>
      <div className={classes.header}>
        {showStepIndication && (
          <div className={classes.stepIndication}>
            {showStepIcon && (
              <img
                className={classes.icon}
                aria-hidden
                alt={t('app.image.program-step-icon')}
                src={IMAGE_ROUTE(iconPath)}
              />
            )}
            {showStepNumber && <Text className={classes.step}>{`0${step}`}</Text>}
          </div>
        )}
        <Text tagName="h2" className={classes.headerTitle} data-hook={`${dataHook}-title`}>
          {title}
        </Text>
      </div>
      {renderDetails()}
    </li>
  );
};
